<script lang="ts">
  import LoadingAtom from "../Loading/LoadingAtom.svelte";
</script>

<div class="loading my-1.5 flex h-14 items-center justify-center space-x-3">
  <LoadingAtom size="size-4" radius="rounded-full" />
  <LoadingAtom size="size-4" radius="rounded-full" />
  <LoadingAtom size="size-4" radius="rounded-full" />
</div>

<style>
  .loading > :global(*) {
    opacity: 0;
    animation: bouncingLoader 0.5s infinite alternate;
  }

  .loading > :global(:nth-child(2)) {
    animation-delay: 0.2s;
  }

  .loading > :global(:nth-child(3)) {
    animation-delay: 0.4s;
  }

  @keyframes bouncingLoader {
    from {
      opacity: 0.2;
      transform: translate(0);
    }
    to {
      opacity: 1;
      transform: translate(0, -1rem);
    }
  }
</style>
